import { observer } from 'mobx-react-lite';
import TvWidgetContainer from './TvWidgetContainer';

const TvFundamental = observer(({ ticker }: { ticker: string }) => {
    return (
        <div className="h-120 w-full">
            <TvWidgetContainer
                scriptSrc="embed-widget-financials"
                configJson={{
                    symbol: `${ticker}`,
                    displayMode: 'compact',
                    locale: 'kr',
                    fontSize: '18',
                }}
            />
        </div>
    );
});

export default TvFundamental;
